<mat-dialog-content>
  <h2 class="dialog-title" mat-dialog-title>{{ 'ADDITIONAL_SERVICE_PLANNING.SCHEDULE_TEMPLATES' |
  transloco }}</h2>

  <div class="templates-grid">
    @for (template of templates; track template) {
      <mat-card class="template-card mb-3">
        <mat-card-content>
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h4>{{ getTemplateLabel(template.name) }}</h4>
              @if (getTemplateDescription(template.description)) {
                <p class="template-description">{{
                getTemplateDescription(template.description) }}</p>
              }
              <div class="template-stats">
                <span class="badge bg-primary me-2">{{template.slots?.length || 0}} slots</span>
                <span class="badge bg-secondary">{{getTotalCapacity(template.slots)}} capacity</span>
              </div>
            </div>
            <div class="action-buttons">
              <button mat-icon-button color="warn" (click)="deleteTemplate(template)">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-icon-button color="primary" (click)="editTemplate(template)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>

  <div class="d-flex justify-content-center mt-3">
    <button mat-fab color="primary" (click)="addTemplate()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-raised-button color="primary" mat-dialog-close>{{ 'FORM.TERMSDIALOGCLOSE' | transloco }}</button>
</mat-dialog-actions>